export enum Currency {
  Euros = 'EUR',
  Dollars = 'USD',
  Pounds = 'GBP',
  Dirhams = 'DAM'
}
